import React from "react";
import PropTypes from "prop-types";
import * as Styled from "./misc/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";

const QAField = (props) => {
  const {
    qa: { id, question, answer, order },
    onEdit,
    onDelete,
  } = props;

  const handleOnEdit = () => {
    onEdit();
  };

  const handleOnDelete = () => {
    onDelete(id, "qas");
  };

  return (
    <Styled.ParagraphContainer>
      <p title={question}>{`(${order}) Q: ${question}`}</p>
      <p title={answer}>{`A: ${answer}`}</p>
      <span onClick={handleOnEdit}>
        <FontAwesomeIcon icon={faEdit} />
      </span>
      <span onClick={handleOnDelete}>
        <FontAwesomeIcon icon={faTimes} />
      </span>
    </Styled.ParagraphContainer>
  );
};

QAField.propTypes = {
  qa: PropTypes.shape({
    id: PropTypes.string,
    question: PropTypes.string,
    answer: PropTypes.string,
    order: PropTypes.number,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default QAField;



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/QAField.js